export default {
  title: "Информация о выставке",
  termsLink: "Общие условия участия",
  managersLink: "Ваши менеджеры",
  buildingTypesLink: "Строительство стенда (монтаж/демонтаж)",
  pavilionMapLink: "Схема комплекса",
  participantManual: "Руководство участника",
  participantDiploma: "Диплом участника",

  deliveryRulesLink: "Правила ввоза/вывоза",
  organizersLink: "Контакты организаторов",
  mountingScheduleLink: "График монтажа/демонтажа",
  complexSchemeLink: "Схема комплекса",

  installationPeriod: "Период монтажа: <br /> {from} — {to}",
  dismantlingPeriod: "Период демонтажа: <br /> {from} — {to}"
};
